import React from "react";
import PropTypes from "prop-types";

// Input hộp chuẩn Geist: viền, bo 6px, cao 44px + chữ 14px — cùng cỡ với SelectDropdown
// để ô gõ, ô ngày và dropdown trên một form không lệch font / chiều cao.
export const GEIST_INPUT =
  "tw-w-full tw-h-11 tw-appearance-none tw-rounded-geist-sm tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg tw-px-3 tw-text-sm tw-text-geist-fg placeholder:tw-text-geist-fg-3 hover:tw-border-geist-border-2 focus:tw-border-geist-accent focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-geist-accent/20 tw-transition-colors";
// Alias giữ tương thích: các chỗ dùng UNDERLINE_CLASS (DatePicker form) nay dùng input hộp.
export const UNDERLINE_CLASS = GEIST_INPUT;
// Ô trong bảng: gọn, chỉ gạch chân (bảng nhiều cột nên giữ tối giản).
export const UNDERLINE_CELL =
  "tw-w-full tw-appearance-none tw-shadow-none tw-rounded-none tw-border-0 tw-border-b tw-border-solid tw-border-geist-border tw-bg-transparent tw-px-0 tw-py-1 tw-text-sm tw-text-geist-fg focus:tw-border-geist-accent focus:tw-outline-none";
export const UNDERLINE_STYLE = { boxShadow: "none", WebkitAppearance: "none", borderRadius: 0, backgroundColor: "transparent" };
const BOX_STYLE = { boxShadow: "none", WebkitAppearance: "none" };

/**
 * Input Bootstrap-proof. Mặc định = input hộp Geist; `cell` = ô bảng gạch chân.
 * forwardRef để dùng với react-hook-form register.
 */
const UnderlineInput = React.forwardRef(function UnderlineInput(
  { className = "", cell = false, style, type = "text", ...rest }, ref
) {
  return (
    <input
      ref={ref}
      type={type}
      // Mọi ô ở đây có dropdown/gợi ý riêng hoặc tự điền — gợi ý lịch sử của
      // trình duyệt chỉ chồng lên và che dropdown. Ô nào cần thì truyền autoComplete.
      autoComplete="off"
      style={{ ...(cell ? UNDERLINE_STYLE : BOX_STYLE), ...style }}
      className={`${cell ? UNDERLINE_CELL : GEIST_INPUT} ${className}`}
      {...rest}
    />
  );
});

UnderlineInput.propTypes = {
  className: PropTypes.string,
  cell: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.string,
};

export default UnderlineInput;
